import { render, staticRenderFns } from "./FlexMod.vue?vue&type=template&id=994f292e"
import script from "./FlexMod.vue?vue&type=script&lang=js"
export * from "./FlexMod.vue?vue&type=script&lang=js"
import style0 from "./FlexMod.vue?vue&type=style&index=0&id=994f292e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports